import type { AppDispatch } from "./index";
import { logout } from "./slices/auth.slice";
import {
  clearHelperData as clearTransfersHelperData,
  clearTransferDraft,
} from "./slices/transfers.slice";
import {
  clearHelperData as clearSuppliersHelperData,
  clearDraft as clearSupplierDraft,
  clearDraftId,
  clearSupplierId,
  clearSupplierDetails,
  clearInitialSupplierItems,
  setSuppliersLoaded,
} from "./slices/suppliers.slice";
import {
  clearHelperData as clearPurchaseOrdersHelperData,
  clearPODraft,
  setPurchaseOrdersLoaded,
} from "./slices/purchaseOrders.slice";
import {
  clearHelperData as clearItemsHelperData,
  clearCategories,
  clearDraft as clearItemDraft,
  setItemsLoaded,
} from "./slices/items.slice";
import {
  clearInventoryHelpData,
  clearOpeningBalanceDraft,
  clearEnteredOpeningBalanceItems,
} from "./slices/inventory.slice";

/** Clears auth and cached feature state. Pair with `baseApi.util.resetApiState()`. */
export function clearAppSessionState(dispatch: AppDispatch) {
  dispatch(logout());

  dispatch(clearTransfersHelperData());
  dispatch(clearTransferDraft());

  dispatch(clearSuppliersHelperData());
  dispatch(clearSupplierDraft());
  dispatch(clearDraftId());
  dispatch(clearSupplierId());
  dispatch(clearSupplierDetails());
  dispatch(clearInitialSupplierItems());
  dispatch(setSuppliersLoaded(false));

  dispatch(clearPurchaseOrdersHelperData());
  dispatch(clearPODraft());
  dispatch(setPurchaseOrdersLoaded(false));

  dispatch(clearItemsHelperData());
  dispatch(clearCategories());
  dispatch(clearItemDraft());
  dispatch(setItemsLoaded(false));

  dispatch(clearInventoryHelpData());
  dispatch(clearOpeningBalanceDraft());
  dispatch(clearEnteredOpeningBalanceItems());
}

/** Full logout: session state + RTK Query cache reset. */
export function performLogout(
  dispatch: AppDispatch,
  resetApiState: () => void,
) {
  clearAppSessionState(dispatch);
  resetApiState();
}
